import React from 'react';

const UserIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" {...props}>
    <path fill="#4B4B4B" fillRule="evenodd" d="M11.59 12.857H.41c-.227 0-.411-.182-.41-.406 0-.013 0-.026.002-.039.183-1.83 2.124-3.84 5.998-3.84 3.875 0 5.816 2.01 6 3.84.022.223-.144.421-.37.443l-.04.002zM6 7.5c-1.745 0-3.27-1.488-3.27-3.884C2.73 1.554 4.05 0 6 0s3.271 1.554 3.271 3.616c0 2.396-1.525 3.884-3.27 3.884z" />
  </svg>

);

export default UserIcon;
